import {
  type DashRouteType,
  URL_PARTNER_SCOPED,
  URL_RETAILER_SCOPED,
} from '@retailer-platform/dashboard/route-patterns'

const URL_LEGACY_ORDERS = `${URL_RETAILER_SCOPED}/orders`
const URL_LEGACY_ORDERS_DELIVERY = `${URL_LEGACY_ORDERS}/delivery`
const URL_LEGACY_ORDERS_PICKUP = `${URL_LEGACY_ORDERS}/pickup`
const URL_LEGACY_ORDERS_SCAN_AND_PAY = `${URL_LEGACY_ORDERS}/scan-and-pay`
const URL_LEGACY_ORDERS_ORDER_DETAILS = `${URL_LEGACY_ORDERS}/:order_delivery_id`
const URL_LEGACY_ORDERS_PARTNER_SCOPED = `${URL_PARTNER_SCOPED}/orders`
const URL_LEGACY_ORDERS_PARTNER_SCOPED_DELIVERY = `${URL_LEGACY_ORDERS_PARTNER_SCOPED}/delivery`
const URL_LEGACY_ORDERS_PARTNER_SCOPED_PICKUP = `${URL_LEGACY_ORDERS_PARTNER_SCOPED}/pickup`
// @hygen:inject scoped-urls

export type DashRouteSet =
  | DashRouteType<'legacy-orders'>
  | DashRouteType<'legacy-orders-delivery'>
  | DashRouteType<'legacy-orders-pickup'>
  | DashRouteType<'legacy-orders-scan-and-pay'>
  | DashRouteType<'legacy-orders-order-details'>
  | DashRouteType<'legacy-orders-partner-scoped'>
  | DashRouteType<'legacy-orders-partner-scoped-delivery'>
  | DashRouteType<'legacy-orders-partner-scoped-pickup'>
// @hygen:inject dash-route-set

export const routes: { [Key in DashRouteSet['identifier']]: string } = {
  'legacy-orders': URL_LEGACY_ORDERS,
  'legacy-orders-delivery': URL_LEGACY_ORDERS_DELIVERY,
  'legacy-orders-pickup': URL_LEGACY_ORDERS_PICKUP,
  'legacy-orders-scan-and-pay': URL_LEGACY_ORDERS_SCAN_AND_PAY,
  'legacy-orders-order-details': URL_LEGACY_ORDERS_ORDER_DETAILS,
  'legacy-orders-partner-scoped': URL_LEGACY_ORDERS_PARTNER_SCOPED,
  'legacy-orders-partner-scoped-delivery': URL_LEGACY_ORDERS_PARTNER_SCOPED_DELIVERY,
  'legacy-orders-partner-scoped-pickup': URL_LEGACY_ORDERS_PARTNER_SCOPED_PICKUP,
  // @hygen:inject route-pair
}

export type DomainRouteName = keyof typeof routes
